import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=b52970e2"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=b52970e2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b52970e2')) {
      api.createRecord('b52970e2', component.options)
    } else {
      api.reload('b52970e2', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=b52970e2", function () {
      api.rerender('b52970e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/compensatoryService/Main.vue"
export default component.exports